/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

angular.module('zeppelinWebApp').directive('popoverHtmlUnsafePopup', popoverHtmlUnsafePopup);

function popoverHtmlUnsafePopup() {
  return {
    restrict: 'EA',
    replace: true,
    scope: {title: '@', content: '@', placement: '@', animation: '&', isOpen: '&'},
    templateUrl: 'components/popover-html-unsafe/popover-html-unsafe-popup.html'
  };
}




// WEBPACK FOOTER //
// ./src/components/popover-html-unsafe/popover-html-unsafe-popup.directive.js